import "./NotFound.modules.css"
function NotFound() {
    return <div className="not-found">The requested page does not exist.</div>
}

export default NotFound;